import React from "react";

import { ReactComponent as GmailIcon } from "../../assets/gmail.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/linkedin.svg";

import "./Contact.scss";

const Contact = () => {
  return (
    <div className="contact">
      <p>Have a Vision? Let’s Build It Together </p>
      <div className="description">
        Whether you're looking to bring your next big idea to life or need
        expert guidance in tech, I offer services in full-stack development,
        cloud solutions, and digital transformation. Let’s collaborate and
        create innovative solutions tailored to your business needs. Feel free
        to reach out via below handles
      </div>
      <div className="social-handles">
        <div>
          <GmailIcon />{" "}
          <a href="mailto:swapnil.shah1996@gmail.com">
            swapnil.shah1996@gmail.com
          </a>
        </div>
        <div>
          <LinkedinIcon />
          <a href="https://www.linkedin.com/in/shah-swapnil">
            https://www.linkedin.com/in/shah-swapnil
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
